var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8 4H9.2C6.35 4 4 6.35 4 9.2V22.8C4 25.65 6.35 28 9.2 28H22.8C25.65 28 28 25.65 28 22.8V9.2C28 6.35 25.65 4 22.8 4ZM18 7H20.65L25.5 10L20.7 25H18.05L20.25 11.3L15.4 25H12.75L15.2 12.15L10.15 25H7.5L10.15 13L7.5 7H10.15L15.15 11.7L12.75 7H15.4L20.2 10.85L18 7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiro);
export default __webpack_public_path__ + "static/media/miro.b907d2d328ed11f948f40e744b2ae73e.svg";
export { ForwardRef as ReactComponent };